import React, { useEffect } from "react";
import { gettext } from "../../adapter";
import NProgress from "../../libraries/progress";
import Filter from "../list/Filter";
import Loader from "../Loader";
import LoadError from "../LoadError";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllStations } from "../../actions/allStationsActions";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import {
  applySearch,
  applyFilters,
  applySorter,
  updateFilterItemCount,
} from "../../utils/sensorUtils";
import { parseAllStations } from "../../utils/allStationUtils";
import AllStationsList from "./AllStationsList";

const RawData = ({ apiUrl }) => {
  const { search } = useLocation();
  let { q, direction, sort, filters } = queryString.parse(search);
  const dispatch = useDispatch();

  const sensors = useSelector((state) => {
    const { sensors, filters } = parseAllStations(state.allStations.items);
    return { ...state.allStations, items: sensors, filters };
  });

  if (sensors.items.length > 0) {
    // Apply search
    sensors.items = applySearch(q, sensors.items);

    sensors.filters = updateFilterItemCount(
      ["group", "type", "owner", "status", "soilMoistureStatus", "period"],
      sensors.items,
      sensors.filters,
      filters
    );

    // Apply filters
    sensors.items = applyFilters(
      ["group", "type", "owner", "status", "soilMoistureStatus", "period"],
      sensors.items,
      sensors.filters,
      filters
    );

    // Sort sensors
    sensors.items = applySorter(sort, direction, sensors.items);
  }

  useEffect(() => {
    NProgress.start();
    dispatch(fetchAllStations(apiUrl));
  }, [dispatch, apiUrl]);

  if (sensors.isFetching === true) {
    return <Loader message={gettext("Loading sensors...")} />;
  }

  if (sensors.loadError) {
    NProgress.done();
    return <LoadError />;
  }

  NProgress.done();

  return (
    <div>
      <div className="l-one-fourth">
        <Filter sensors={sensors.items} filters={sensors.filters} />
      </div>
      <div className="l-three-fourth">
        <div className="panel">
          <h2>{gettext("Soil sensors")}</h2>
          <AllStationsList sensors={sensors.items} />
        </div>
      </div>
    </div>
  );
};

export default RawData;
